// Slot-only markup: the panel ships structure without any visible word. Every
// string ("Notifications", "More", empty/error copy) is painted by
// notificationCenterController at init/render time, so the raw HTML served to
// non-JS crawlers carries zero notification chrome text ahead of page content.
export const notificationCenterMarkup = String.raw`
<div class="ntf-center" id="notificationCenter" data-auth-pending="true">
  <button class="ntf-bell" id="notificationBell" type="button" aria-label="Notifications" aria-expanded="false" aria-controls="notificationPanel">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9"></path><path d="M10 21h4"></path></svg>
    <span class="ntf-badge" id="notificationBadge" hidden></span>
  </button>
  <section class="ntf-panel" id="notificationPanel" aria-label="Notifications" hidden>
    <header class="ntf-header">
      <strong id="notificationTitle"></strong>
      <button class="ntf-more-link" id="notificationMore" type="button" data-proto-click="showView('messages');setActiveTab('profile')"></button>
    </header>
    <div class="ntf-list" id="notificationList" role="feed" aria-live="polite"></div>
    <div class="ntf-skeleton" id="notificationSkeleton" hidden></div>
    <div class="ntf-error" id="notificationError" role="alert" hidden></div>
    <div class="ntf-empty" id="notificationEmpty" hidden></div>
  </section>
</div>`;
